import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";

function Newsletter_42() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter March 2026
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            New York Legislature Passes Corporate Greenhouse Gas Disclosure
            Bill.
          </title>
          <meta
            name="description"
            content="New York State lawmakers have approved the Climate Corporate Data Accountability Act, positioning the state to join California in requiring standardised, public greenhouse gas reporting from large businesses operating in the jurisdiction."
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          New York Legislature Passes Corporate Greenhouse Gas Disclosure Bill.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Mar_2026_1.webp")}
            alt="New York Legislature Passes Corporate Greenhouse Gas Disclosure Bill."
            loading="lazy"
          />
        </figure>
        <p>
          New York State lawmakers have approved the Climate Corporate Data
          Accountability Act, positioning the state to join California in
          requiring standardised, public greenhouse gas reporting from large
          businesses operating in the jurisdiction. The measure targets
          U.S.-based companies with more than US$1 billion in annual revenue and
          seeks to close gaps in corporate climate data, particularly across
          value chains. If enacted, it would cover public and private firms.
        </p>
        <p>
          Under the legislation, companies would be required to report Scope 1
          and Scope 2 emissions beginning in 2028, covering direct operational
          emissions and emissions from purchased energy. The disclosure
          framework will be developed and overseen by the state’s Department of
          Environmental Conservation, which must finalize detailed reporting
          rules by the end of 2027. The reporting system is expected to follow
          widely recognized emissions accounting standards and will require
          companies to submit verified emissions data through an established
          digital reporting platform.
        </p>
        <p>
          The law also introduces mandatory reporting of Scope 3 emissions,
          which include indirect emissions across a company’s value chain such
          as those generated by suppliers, transportation, product use, and
          waste management. Scope 3 disclosures would begin in 2029, reflecting
          the complexity of collecting value-chain data. To enhance credibility
          and comparability, companies would be required to obtain independent
          third-party assurance for reported emissions data, with verification
          standards expected to strengthen over time as the reporting system
          matures.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The proposed disclosure requirements are likely to expand
            climate-related reporting costs and compliance obligations for large
            companies operating in New York, particularly in measuring
            value-chain emissions. Firms may need to invest in emissions
            accounting systems, supplier data collection, and third-party
            verification processes. At the same time, improved transparency
            could influence capital allocation as investors increasingly
            incorporate climate risk and transition exposure into
            decision-making, potentially affecting corporate financing
            conditions and supply-chain engagement across high-emitting sectors.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          UK Releases Final Sustainability Reporting Standards Aligned With ISSB
          Framework.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/Newsletter/Mar_2026_2.webp")}
              alt="UK Releases Final Sustainability Reporting Standards Aligned With  ISSB Framework."
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          The United Kingdom has published its final UK Sustainability Reporting
          Standards, UK SRS S1 and UK SRS S2, for voluntary use from 25 February
          2026, marking a significant step in aligning domestic disclosure
          practice with the International Sustainability Standards Board’s
          global baseline. The standards are based on IFRS S1 and IFRS S2, which
          were issued in June 2023 and became effective for annual periods
          beginning on or after 1 January 2024.
        </p>
        <p>
          The framework follows a 12-week consultation held from 25 June to 17
          September 2025, alongside work on assurance oversight. Official
          records show 184 responses on the core technical amendments. The final
          version retains close alignment with the international model while
          removing embedded effective dates, allowing any future mandatory
          application to be set through regulation, while voluntary adopters may
          use the standards immediately.
        </p>
        <p>
          The final package also reflects later ISSB greenhouse-gas disclosure
          amendments issued in December 2025, including updates affecting
          financed emissions and Scope 3 treatment. In parallel, the Financial
          Conduct Authority is consulting on listing-rule changes that would
          phase in climate disclosures from 1 January 2027 for in-scope listed
          entities, with Scope 3 and broader sustainability topics proposed on a
          comply-or-explain basis.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Companies can begin preparing by aligning internal governance, risk
            management, and data systems with the structure of the new UK
            Sustainability Reporting Standards. This includes strengthening
            climate and sustainability data collection, improving oversight at
            the board and management levels, and integrating sustainability
            risks into financial planning. Firms may also review existing
            disclosures against IFRS S1 and S2 principles, develop internal
            controls for non-financial data, and build cross-functional
            processes to support consistent, decision-useful reporting.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Dutch Financial Markets Authority Establishes Stricter Compliance
          Standards for Sustainability and Environmental Claims.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Mar_2026_3.webp")}
            alt="Dutch Financial Markets Authority Establishes Stricter Compliance Standards for Sustainability and Environmental Claims."
            loading="lazy"
          />
        </figure>
        <p>
          The Dutch Authority for the Financial Markets has intensified its
          oversight of the financial sector by mandating that banks and
          investment firms significantly refine sustainability related
          communications. Following extensive evaluations spanning recent years,
          the regulator identified a persistent gap between marketing narratives
          and the granular data required to substantiate environmental or social
          claims. This initiative transitions ESG reporting from a voluntary
          storytelling exercise into a strictly evidence based disclosure
          environment. It ensures that all assertions are factually accurate,
          representative of entire portfolios, and devoid of vague terminology
          that could potentially obscure actual impact.
        </p>
        <p>
          Strategic focus areas for 2026 include the mandatory clarification of
          climate neutrality pathways, ESG rating methodologies, and the
          accessibility of supporting evidence. Financial institutions must now
          provide direct links to underlying data and explicitly define metrics
          within the same information layer as the claim. This shift addresses
          long standing issues where organizations emphasized minor green
          initiatives while neglecting broader portfolio impacts. Historically,
          the regulator has noted that while market participants increasingly
          adopt sustainability guidelines, many products previously classified
          under SFDR Article 9 required reclassification due to a lack of robust
          and verifiable performance data.
        </p>
        <p>
          This regulatory advancement builds upon foundational standards
          established in 2023, reflecting a broader European trend toward
          eradicating misleading disclosures. Past assessments revealed that a
          significant portion of sustainable funds lacked sufficient
          quantitative evidence to meet rigorous taxonomy criteria, leading to a
          renewed emphasis on transparency. By prioritizing the integrity of
          sustainability claims, the current framework seeks to protect
          investors from deceptive signaling and ensure that capital is directed
          toward genuine transition efforts. The integration of these standards
          into daily supervision signifies a permanent shift toward
          accountability in the global sustainable finance landscape.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The shift toward stricter reporting rules acts as a powerful driver
            for moving money into more efficient businesses. By replacing vague
            promises with real data, these standards help the market value
            companies based on their true environmental risks and performance.
            This change reduces the chance of sudden market shocks caused by
            misleading information. Ultimately, it creates a more stable economy
            where investment flows are guided by actual results rather than just
            following popular sustainability trends.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Ireland Launches Comprehensive Circular Economy Strategy.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Mar_2026_4.webp")}
            alt="Ireland Launches Comprehensive Circular Economy Strategy."
            loading="lazy"
          />
        </figure>
        <p>
          Ireland has launched the Circular Economy Strategy 2026-2028, a
          comprehensive whole-of-government initiative to enhance resource
          efficiency, minimize waste, and integrate circular principles into
          climate and industrial policies. Building on the 2022 strategy and
          Circular Economy Act, this plan targets an annual two percentage point
          rise in the circular material use rate (CMUR), from around 8%
          currently to 12% by 2030, addressing the low 2% rate recorded in 2020.
          Key measures include a National Pilot Repair Voucher Scheme by 2027,
          funded via the Circular Economy Fund, to make repairs more affordable
          and extend product lifespans.
        </p>
        <p>
          Sector-specific roadmaps cover construction, agriculture, retail,
          packaging, textiles, and electronics, aligning with EU regulations
          like Ecodesign for Sustainable Products. Digital Product Passports
          will provide transparency on sustainability for priority items such as
          textiles and furniture, fostering informed consumer choices and
          regulatory compliance. These efforts support ambitions like halving
          food waste by 2030 and achieving 90% plastic bottle collection by
          2029, advancing past successes such as 35% municipal waste recycling
          by 2009.
        </p>
        <p>
          The strategy decides to establish local reuse hubs in communities to
          facilitate material recovery and reuse at scale, alongside mandatory
          green public procurement standards prioritising circular products. It
          mandates the development of innovation funds for collaborative R&D
          projects across sectors, targeting breakthroughs in biodegradable
          materials and closed-loop manufacturing processes. Further decisions
          include annual reporting frameworks to monitor progress on waste
          prevention hierarchies and incentives for businesses adopting
          zero-waste certifications.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Ireland's Circular Economy Strategy delivers transformative impacts
            for industries, slashing operational costs by up to 20% through
            optimized material loops and repair voucher incentives that extend
            product lifespans and curb raw material reliance. Sector roadmaps in
            construction, textiles, and electronics drive profound compliance
            with EU Ecodesign and Digital Product Passports, unlocking green
            procurement opportunities and spurring breakthroughs in closed-loop
            innovation.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          India Initiates Comprehensive Review of ESG Ratings Regulatory
          Framework.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Mar_2026_5.webp")}
            alt="India Initiates Comprehensive Review of ESG Ratings Regulatory Framework.."
            loading="lazy"
          />
        </figure>

        <p>
          India has begun a fresh review of its regulatory framework for ESG
          Rating Providers, with the securities regulator constituting a working
          group in February 2026 to examine the current rules and recommend
          refinements. The move follows market feedback on usability,
          consistency and disclosure practices, and signals a new phase in
          building a more reliable sustainability data ecosystem for capital
          markets.
        </p>
        <p>
          The review builds on a broader reform cycle already underway. Business
          Responsibility and Sustainability Reporting was introduced in 2021,
          and mandatory reporting for the top 1,000 listed companies has been in
          effect since FY 2022-23. In 2023, the regulator also introduced the
          BRSR Core framework, with reasonable assurance being phased in from
          the top 150 listed entities in FY 2023-24 to the top 1,000 by FY
          2026-27.
        </p>
        <p>
          India’s ESG ratings architecture has also been tightened through the
          2023 consultation on ESG Rating Providers, the 2024 master circular,
          and further procedural clarifications issued in April and July 2025.
          These measures formalised registration, recognised issuer-pays and
          subscriber-pays models, and expanded transparency requirements,
          including stock exchange visibility for issuer ratings.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The standards signal a move toward globally aligned, decision-useful
            sustainability disclosures more closely linked to financial
            reporting. Companies should focus on strengthening governance
            oversight, improving the reliability of climate and sustainability
            data, and integrating material ESG risks into enterprise risk
            management and strategy. The framework also highlights the
            importance of value-chain transparency, scenario-based climate
            assessment, and structured internal controls for non-financial
            information to support consistent and comparable corporate
            disclosures.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default Newsletter_42;
